<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  methods: {
    init() {
      window.onload = function () {
        document.addEventListener('touchstart', function (event) {
          if (event.touches.length > 1) {
            event.preventDefault()
          }
        })
        document.addEventListener('gesturestart', function (event) {
          event.preventDefault()
        })
      }

    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
